import React from 'react';
// import './../../scss/button.scss';

const IButton = ({
  children,
  onClick,
  icon: Icon,
  variant = 'primary',
  size = 'md',
  className = ''
}) => {
  return (
    <button
      onClick={onClick}
      className={`ibtn ${variant} ${size} ${className}`}
    >
      {Icon && <Icon className="icon left" size={20} />}
    </button>
  );
};

export default IButton;
